import React, { useRef, useState, useEffect } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollSmoother from "gsap/ScrollSmoother";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import styles from "./page.module.scss";
import PLvideo from "../../assets/videos/skyline.mp4";
// import PLVerticalVideo from "../../assets/videos/CV-PonteLuis-1080.mp4";

import MSLogo from "../../assets/logo/MS-logo-W.svg";
import MSLogoBlack from "../../assets/logo/MS-logo.svg";
import GenysPP from "../../assets/images/DenysHS4.avif";
import LinkedIn from "../../assets/svgs/LinkedIn.svg";

import { Link } from "react-router-dom";
import Services from "../../components/Services";
import AnimatedMap from "../../components/AnimatedMap";

import windFarm from "../../assets/images/sandWindFarm.png";
import UploadCV from "../../components/UploadCV";
import classNames from "classnames";
import InitialLoadingScreen from "../../components/InitialLoadingScreen";
import AnimatedMapMobile from "../../components/AnimatedMapMobile";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, ScrollSmoother, SplitText);

export function Home() {
  const linksBar = useRef(null);
  const linksBarMob = useRef(null); // Mobile version

  const linkContact = useRef(null);
  const linkContactMob = useRef(null); // Mobile version

  const motto = useRef(null);
  const mottoMob = useRef(null); // Mobile version already exists

  const logoRef = useRef(null);
  const logoRefMob = useRef(null); // Mobile version already exists

  const getInTouch = useRef(null);

  const footerLocation = useRef(null);

  const footerSocialLinks = useRef(null);

  const footerHomeLinks = useRef(null);

  const footerFinalLinks = useRef(null); // Assuming this is the same as footerHomeLinks in mobile version

  const targetedSearch = useRef(null);
  const contactUsButton = useRef(null);
  const map = useRef(null);
  const uploadCV = useRef(null);
  const messageSection = useRef(null);
  const messageFromFounderTitle = useRef(null);
  const PP = useRef(null);
  const testimonial1 = useRef(null);
  const footerHeader = useRef(null);
  const placedIn = useRef(null);
  const globalScope = useRef(null);

  const [isUploadCVVisible, setIsUploadCVVisible] = useState(false);
  const uploadCVRef = useRef(null);
  const initialLoading = useRef(null);
  const testimonials = useRef(null);
  const targetedSearchImage = useRef(null);
  const iconsContainer = useRef(null);

  const servicesSection = useRef(null);

  const messageSectionParent = useRef(null);
  const footerLink1 = useRef(null);
  const footerLink2 = useRef(null);
  const footerLink3 = useRef(null);
  const footerLink4 = useRef(null);

  const initialLoadingTime = 2.5;

  // Button on Click of CV
  const handleShowUploadCV = () => {
    setIsUploadCVVisible(true);
    // Allow the component to mount before starting the animation
    gsap.to(uploadCVRef.current, {
      x: "-100%",
      opacity: 1,
      duration: 0.7,
      ease: "power.inOut",
    });
  };

  const animateUploadCVOut = () => {
    gsap.to(uploadCVRef.current, {
      x: "0%",
      opacity: 0,
      duration: 0.5,
      ease: "power.inOut",
    });
  };
  // Button To Close
  const handleCloseUploadCV = () => {
    animateUploadCVOut(); // Start the animation
    setTimeout(() => {
      setIsUploadCVVisible(false); // After the animation, hide the component
    }, 500); // Duration should match the animation duration
  };

  const scrollToTop = () => {
    gsap.to(window, {
      duration: 5,
      scrollTo: { y: 0, autoKill: true }, // Scroll to the very top of the page
      ease: "power3.inOut",
    });
  };

  const scrollToBottom = () => {
    gsap.to(window, {
      duration: 7,
      scrollTo: { y: document.body.scrollHeight, autoKill: true }, // Scroll to the very bottom of the page
      ease: "power3.inOut",
    });
  };

  const scrollToBottomAndContact = () => {
    gsap.to(window, {
      duration: 7,
      scrollTo: { y: document.body.scrollHeight, autoKill: true }, // Scroll to the very bottom of the page
      ease: "power3.inOut",
    });

    const delay = 3;
    const stagger = 0.2;
    gsap.to(footerLink1.current, {
      x: 20, // move the items up
      opacity: 1, // start with 0 opacity
      ease: "power2.out",
      duration: 1,
      delay: delay,
    });
    gsap.to(footerLink2.current, {
      x: 20, // move the items up
      opacity: 1, // start with 0 opacity
      ease: "power2.out",
      duration: 1,
      delay: delay + stagger,
    });
    gsap.to(footerLink3.current, {
      x: 20, // move the items up
      opacity: 1, // start with 0 opacity
      ease: "power2.out",
      duration: 1,
      delay: delay + 2 * stagger,
    });
    gsap.to(footerLink4.current, {
      x: 20, // move the items up
      opacity: 1, // start with 0 opacity
      ease: "power2.out",
      duration: 1,
      delay: delay + 3 * stagger,
    });
  };

  const scrollToServices = () => {
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: servicesSection.current.offsetTop, autoKill: true },
      ease: "power3.inOut",
    });
  };

  const scrollToMessage = () => {
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: messageSectionParent.current, autoKill: true },
      ease: "power3.inOut",
    });
  };

  useGSAP(() => {
    const mm = gsap.matchMedia();

    gsap.to(initialLoading.current, {
      y: "-100%", // Animate offscreen to the right
      opacity: 0,
      duration: 1,
      delay: initialLoadingTime,
      ease: "power3.in",
    });

    gsap.from([linksBar.current, linksBarMob.current], {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      delay: initialLoadingTime + 2, // Add a small delay before starting the animation
    });

    // Animate the contact link (both desktop and mobile)
    gsap.from([linkContact.current, linkContactMob.current], {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      delay: initialLoadingTime + 5.5, // Add a small delay before starting the animation
    });

    gsap.from([contactUsButton.current], {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      delay: initialLoadingTime + 5, // Add a small delay before starting the animation
    });

    gsap.from(globalScope.current.children, {
      y: -50,
      opacity: 0,
      stagger: 0.3,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: globalScope.current, // Use the specific element as the trigger
        start: "top+=100vh center", // Start animation when top of trigger reaches 100vh
      },
    });

    gsap.from(map.current, {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: map.current, // Use the specific element as the trigger
        start: "top+=100vh center", // Start animation when top of trigger reaches 100vh
      },
    });

    gsap.from(PP.current, {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: PP.current, // Use the specific element as the trigger
        start: "top+=100vh center", // Start animation when top of trigger reaches 100vh
      },
    });

    gsap.from(footerHeader.current.children, {
      y: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 1,
      scrollTrigger: {
        trigger: footerHeader.current,
        start: "top 80%",
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(testimonials.current.children, {
      x: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: testimonials.current,
        start: "top 80%",
        toggleActions: "play none none none", // only play the animation once
      },
    });

    const splitPlacedIn = new SplitText(placedIn.current, {
      type: "words",
    });
    gsap.from(splitPlacedIn.words, {
      opacity: 0,
      y: 20,
      stagger: 0.05,
      duration: 2,
      ease: "power1.out",
      scrollTrigger: {
        trigger: placedIn.current,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });

    gsap.from(messageFromFounderTitle.current, {
      y: -50,
      opacity: 0,
      duration: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: messageFromFounderTitle.current, // Use the specific element as the trigger
        start: "top+=100vh center", // Start animation when top of trigger reaches 100vh
      },
    });

    gsap.from(uploadCV.current.children, {
      x: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: uploadCV.current,
        start: "top+=100vh center", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(messageSection.current.children, {
      x: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: messageSection.current,
        start: "top+=100vh center", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    const mottoElements = [motto.current, mottoMob.current].filter(Boolean);

    if (mottoElements.length > 0) {
      // Animate the motto (both desktop and mobile)
      const splitTextInstance = new SplitText(mottoElements, {
        type: "words",
      });

      gsap.from(splitTextInstance.words, {
        opacity: 0,
        y: 20,
        stagger: 0.1,
        duration: 0.6,
        ease: "power1.out",
        delay: initialLoadingTime + 3,
      });
    }

    const animateLogo = (logoElement) => {
      const splitLogo = new SplitText(logoElement, {
        type: "chars",
      });

      gsap.from(splitLogo.chars, {
        opacity: 0,
        y: 50, // Translate upwards
        stagger: 0.1, // Stagger each animation slightly
        duration: (index) => 0.6 + index * 0.2, // Different speeds based on index
        ease: "power2.out",
        delay: initialLoadingTime + 3,
      });
    };

    // Apply the animation to both desktop and mobile logos
    [logoRef.current, logoRefMob.current].forEach((logoElement) => {
      if (logoElement) {
        animateLogo(logoElement);
      }
    });

    const animateLogoScrollOut = (logoElement) => {
      const splitLogoScrollOut = new SplitText(logoElement, {
        type: "chars",
      });

      // Create a scroll-triggered animation
      gsap.to(splitLogoScrollOut.chars, {
        y: (index) => -200 - index * 30, // Translate upwards at different speeds
        opacity: 0,
        stagger: 0.1, // Optional: stagger the start of each animation
        ease: "power1.out",
        scrollTrigger: {
          trigger: logoElement, // Use the specific element as the trigger
          start: "top+=100vh center", // Start animation when top of trigger reaches 100vh
          scrub: true, // Smooth scrubbing, each pixel moves the animation
        },
      });
    };

    // Apply the scroll-out animation to both desktop and mobile logos
    [logoRef.current, logoRefMob.current].forEach((logoElement) => {
      if (logoElement) {
        animateLogoScrollOut(logoElement);
      }
    });

    gsap.from(targetedSearch.current.children, {
      y: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: targetedSearch.current,
        start: "top+=100vh center", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(iconsContainer.current.children, {
      x: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.35, // stagger the appearance of each item
      ease: "power2.out",
      duration: 0.5,
      scrollTrigger: {
        trigger: iconsContainer.current,
        start: "top+=100vh center", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(targetedSearchImage.current.children, {
      y: -50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.5, // stagger the appearance of each item
      ease: "power2.out",
      delay: 0.2,
      duration: 1,
      scrollTrigger: {
        trigger: targetedSearchImage.current,
        start: "top+=100vh center", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(footerHomeLinks.current.children, {
      y: 50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.12, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: footerHomeLinks.current,
        start: "top 80%", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(footerSocialLinks.current.children, {
      y: 50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.12, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.2,
      scrollTrigger: {
        trigger: footerSocialLinks.current,
        start: "top 80%", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(footerLocation.current.children, {
      y: 50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.12, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      delay: 0.4,
      scrollTrigger: {
        trigger: footerLocation.current,
        start: "top 80%", // start when the section enters the viewport
        toggleActions: "play none none none", // only play the animation once
      },
    });

    gsap.from(footerFinalLinks.current.children, {
      y: 50, // move the items up
      opacity: 0, // start with 0 opacity
      stagger: 0.12, // stagger the appearance of each item
      ease: "power2.out",
      duration: 1,
      scrollTrigger: {
        trigger: footerLocation.current,
        start: "top 80%",
        toggleActions: "play none none none", // only play the animation once
      },
    });
  });

  console.log(isUploadCVVisible);

  return (
    <div>
      <div
        className={styles.initialLoadingContainer}
        ref={initialLoading}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          zIndex: 1000,
        }}
      >
        <InitialLoadingScreen />
      </div>
      <div className={styles.backgroundVideo}>
        <video
          className={styles.video}
          src={PLvideo}
          autoPlay
          loop
          muted
          playsInline
        ></video>
      </div>
      <div className={styles.hero}>
        {/* Desktop Version */}
        <div className={styles.desktop}>
          <header className={styles.grid}>
            <div className={styles.navbar}>
              <div className={styles.linksBar} ref={linksBar}>
                <img src={MSLogo} />
              </div>
              <div className={styles.linkContact} ref={linkContact}>
                <Link to="https://fr.linkedin.com/in/denys-maksymenko">
                  <img src={LinkedIn} className={styles.linkedIn} />
                </Link>
              </div>
            </div>
          </header>
          <div
            className={`${styles.logoContainer} ${styles.gridNoVerticalSpacing}`}
          >
            <div className={styles.grid}>
              <div className={styles.logo} ref={motto}>
                <div className={styles.title}>Maximal Search</div>A recruitment
                partner in financial services who truly understands your
                business and will provide a maximal experience.
              </div>
              <div
                className={styles.buttonContainer}
                ref={contactUsButton}
                onClick={scrollToBottom}
              >
                <div
                  className={styles.button}
                  onClick={scrollToBottomAndContact}
                >
                  Contact us
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.spacer100}></div>
      <div className={styles.targetedSearch}>
        <div className={`${styles.grid} ${styles.gridNoVerticalSpacing}`}>
          <div className={styles.leftContainer} ref={targetedSearch}>
            <div className={styles.targeted}>
              Targeted search for every single role.
            </div>
            <div className={styles.mainText}>
              Tired of seeing the same candidates on the market again and again
              with no variety? We believe no two roles are the same, so we’ve
              decided to provide a fully tailored service to each particular
              role where we will headhunt for your role specifically and reach
              out to diverse candidates across different geographies, ensuring a
              diverse shortlist every time
            </div>
            <div className={styles.iconsContainer} ref={iconsContainer}>
              <div className={styles.item}>
                <div className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="76"
                    height="78"
                    viewBox="0 0 76 78"
                    fill="none"
                  >
                    <path
                      d="M52.3476 29.2905V17.5767C52.3476 9.5255 45.8223 3.00014 37.775 3.00014C29.7237 2.96551 23.1676 9.45982 23.1328 17.5111V17.5767V29.2905"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M56.0912 74.4737H19.4494C10.3624 74.4737 3 67.114 3 58.0351V36.7247C3 27.6458 10.3624 20.2861 19.4494 20.2861H56.0912C65.1782 20.2861 72.5405 27.6458 72.5405 36.7247V58.0351C72.5405 67.114 65.1782 74.4737 56.0912 74.4737Z"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className={styles.text}>Confidentiality</div>
              </div>
              <div className={styles.item}>
                <div className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="87"
                    height="74"
                    viewBox="0 0 87 74"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M42.8726 5.93116C35.5263 5.93116 29.5718 11.8832 29.5718 19.2272C29.5718 26.5713 35.5263 32.5234 42.8726 32.5234C50.2138 32.5234 56.1687 26.5719 56.1687 19.2272C56.1687 11.8826 50.2138 5.93116 42.8726 5.93116ZM23.6406 19.2272C23.6406 8.60521 32.2529 0 42.8726 0C53.4882 0 62.0999 8.60576 62.0999 19.2272C62.0999 29.8489 53.4882 38.4546 42.8726 38.4546C32.2529 38.4546 23.6406 29.8493 23.6406 19.2272Z"
                      fill="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.739 63.3414C27.2272 66.7064 34.7723 68.0891 42.9889 68.0689H43.0035C51.2202 68.0891 58.765 66.7064 65.2533 63.3418C61.487 54.5538 53.204 50.3114 43.0039 50.3375H42.9885C32.7756 50.3114 24.5059 54.5439 20.739 63.3414ZM42.9964 44.4064C30.0548 44.3755 18.4896 50.4016 14.2556 63.7902L13.5547 66.0065L15.5395 67.2164C23.6922 72.1864 33.1616 74.0234 42.9964 74.0001C52.8311 74.0234 62.3004 72.1864 70.453 67.2164L72.4379 66.0065L71.7369 63.7902C67.5075 50.4142 55.9252 44.3755 42.9964 44.4064Z"
                      fill="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.739 63.3414C27.2272 66.7064 34.7723 68.0891 42.9889 68.0689H43.0035C51.2202 68.0891 58.765 66.7064 65.2533 63.3418C61.487 54.5538 53.204 50.3114 43.0039 50.3375H42.9885C32.7756 50.3114 24.5059 54.5439 20.739 63.3414ZM42.9964 44.4064C30.0548 44.3755 18.4896 50.4016 14.2556 63.7902L13.5547 66.0065L15.5395 67.2164C23.6922 72.1864 33.1616 74.0234 42.9964 74.0001C52.8311 74.0234 62.3004 72.1864 70.453 67.2164L72.4379 66.0065L71.7369 63.7902C67.5075 50.4142 55.9252 44.3755 42.9964 44.4064Z"
                      stroke="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.7035 41.045C12.353 41.0209 3.81196 45.4151 0.700826 55.2541L0 57.4704L1.98476 58.6803C5.17676 60.6262 8.64194 61.9033 12.2584 62.6613L15.1609 63.2699L16.3779 57.4649L13.4754 56.8567C11.2761 56.3953 9.19825 55.7187 7.258 54.7966C9.87096 49.5412 15.1157 46.9592 21.6884 46.9762L24.6539 46.9837L24.6691 41.0525L21.7035 41.045Z"
                      fill="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M30.0385 12.1513L27.3002 11.0128C19.9761 7.96752 11.5658 11.4345 8.51878 18.7628C5.47182 26.091 8.94472 34.4989 16.2688 37.544C22.318 40.0592 29.0984 38.1347 32.997 33.2708L34.8517 30.9564L30.2236 27.2471L28.3689 29.561C26.0786 32.4187 22.0932 33.5424 18.5459 32.0675C14.2454 30.2795 12.2065 25.3424 13.9954 21.0399C15.7843 16.7373 20.7226 14.7013 25.0231 16.4894L27.7614 17.628L30.0385 12.1513Z"
                      fill="black"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M64.4382 41.045C73.7889 41.0209 82.3298 45.4151 85.4409 55.2541L86.1419 57.4704L84.157 58.6803C80.9652 60.6262 77.4998 61.9033 73.8834 62.6613L70.9811 63.2699L69.764 57.4649L72.6663 56.8567C74.8656 56.3953 76.9435 55.7187 78.8838 54.7966C76.2709 49.5412 71.0262 46.9592 64.4537 46.9762L61.4881 46.9837L61.4727 41.0525L64.4382 41.045Z"
                      fill="black"
                    />
                    <path
                      stroke-width="6"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M55.0344 12.9522L57.6568 11.567C63.7046 8.37208 71.3538 9.86978 75.6998 15.4607C80.5704 21.7268 79.4364 30.7528 73.1739 35.6207C66.909 40.4902 57.8826 39.3632 53.0111 33.0968L51.1914 30.7555L55.8739 27.1154L57.6939 29.457C60.5536 33.1355 65.8536 33.7986 69.5337 30.9378C73.2111 28.0794 73.8765 22.7797 71.0169 19.1008C68.4681 15.8221 63.9758 14.9368 60.427 16.8114L57.8051 18.1966L55.0344 12.9522Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className={styles.text}>Variety</div>
              </div>
              <div className={styles.item}>
                <div className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                  >
                    <path
                      d="M24.7109 36.541V56.641"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M40.8359 26.9238V56.6403"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M56.9551 47.1631V56.6398"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="square"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M41.9833 72.616H71.6667V10.9492H10V72.616H27.8133"
                      stroke="black"
                      stroke-width="6"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
                <div className={styles.text}>Research</div>
              </div>
              <div className={styles.item}>
                <div className={styles.icon}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="82"
                    height="82"
                    viewBox="0 0 82 82"
                    fill="none"
                  >
                    <path
                      d="M36.6349 17.5566L38.6974 17.5567V43.549V44.049H39.1974H65.1896V46.1115C65.1896 51.7591 63.5147 57.2798 60.3771 61.9754L60.7928 62.2532L60.377 61.9754C57.2395 66.6714 52.7799 70.3311 47.5621 72.4926C42.3446 74.6537 36.603 75.2192 31.0641 74.1175C25.525 73.0158 20.437 70.2959 16.4436 66.3027C12.4501 62.3092 9.73054 57.2213 8.62876 51.6822C7.52698 46.1431 8.09244 40.4018 10.2537 35.184C12.4149 29.9663 16.0749 25.5066 20.7706 22.369C25.4665 19.2314 30.9872 17.5566 36.6349 17.5566ZM34.5723 22.3192V21.7625L34.0188 21.8221C30.1121 22.2429 26.3508 23.6015 23.0624 25.7988C19.045 28.4832 15.9137 32.2986 14.0647 36.7625L14.5266 36.9538L14.0647 36.7625C12.2157 41.2265 11.7319 46.1384 12.6745 50.8772C13.6171 55.6161 15.9438 59.9692 19.3604 63.3857C22.7769 66.8023 27.1299 69.1292 31.8688 70.0717C36.6077 71.0141 41.5196 70.5303 45.9836 68.6813C50.4476 66.8323 54.2628 63.7011 56.9472 59.6839C59.1447 56.3953 60.5033 52.6342 60.924 48.7275L60.9836 48.174H60.4269H34.5723V22.3192Z"
                      fill="black"
                      stroke="black"
                    />
                    <path
                      d="M49.1348 33.3262V33.8262H49.6348H70.8646H71.4213L71.3617 33.2726C70.7677 27.7554 68.3072 22.5749 64.3469 18.6143L64.3469 18.6142C60.3862 14.6536 55.2057 12.1934 49.6883 11.5993L49.1348 11.5397V12.0965V33.3262ZM75.6269 35.8887V37.9512H45.0098V7.33398H47.0723C54.6456 7.33395 61.9087 10.3424 67.2635 15.6974L67.617 15.3439L67.2635 15.6974C72.6186 21.0525 75.6269 28.3155 75.6269 35.8887Z"
                      fill="black"
                      stroke="black"
                    />
                  </svg>
                </div>
                <div className={styles.text}>Analysis</div>
              </div>
            </div>
          </div>
          <div className={styles.rightContainer} ref={targetedSearchImage}>
            <img src={windFarm} />
          </div>
        </div>
      </div>
      <div ref={servicesSection}>
        <Services />
      </div>
      <div className={styles.placementsMapC}>
        <div
          className={`${styles.grid} ${styles.gridNoVerticalSpacing}`}
          ref={globalScope}
        >
          <div className={styles.mainTitle}>Why Choose Us?</div>
          <div className={styles.dataDriven}>
            <div className={styles.title}>Data-Driven Recruitment</div>
            <div className={styles.content}>
              We leverage advanced AI tools and data insights to connect you
              with the right talent,{" "}
              <div className={styles.bold}>usually within one week.</div>
            </div>
          </div>
          <div className={styles.candidateExperience}>
            <div className={styles.title}>Candidate Experience</div>
            <div className={styles.content}>
              We prioritise a respectful and seamless candidate journey
              maintaining a{" "}
              <div className={styles.bold}>
                98% candidate satisfaction rate, and an 88% offer acceptance
                rate
              </div>
            </div>
          </div>
          <div className={styles.diversity}>
            <div className={styles.title}> Diversity & Global Reach</div>
            <div className={styles.content}>
              <div className={styles.bold}>
                We’ve hired in 12 countries and counting
              </div>
              , with 35% of our placements involving relocation, and we ensure a
              diverse shortlist of candidates every time”
            </div>
          </div>
        </div>
        <div className={styles.mapContainer}>
          <AnimatedMap className={styles.mapSVG} />
        </div>
        <div className={styles.mapContainerMobile}>
          <AnimatedMapMobile className={styles.mapSVG} />
        </div>
      </div>

      <div className={styles.testimonials}>
        <div
          className={`${styles.grid} ${styles.gridNoVerticalSpacing}`}
          ref={testimonials}
        >
          <div className={styles.mainTitle}>Testimonials</div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial1}>
              Denys is a thorough professional who really understands the
              requirements of companies and aligns them with my strengths and
              personal goals. During my association with Denys, he was very
              prompt in his communication and I highly recommend Denys for his
              ability to deliver the best outcome.
              <div className={styles.title}>ESG Senior Analyst</div>
            </div>
          </div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial2}>
              Denys is one of the best recruiting consultants in the risk space.
              He brings a highly personalised, frank and straightforward
              approach, which is refreshing. He is very thoughtful and provided
              important inputs and suggestions; and was always available to help
              in any way. It was a pleasure working with him!
              <div className={styles.title}>Leveraged Finance ESG Analyst</div>
            </div>
          </div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial1}>
              Competent, insightful and communicative. Denys recruited me for my
              current position and is one of my team's go-to consultants for
              external hires. From our first conversation, I was impressed by
              his understanding of the risk profession, the company's culture
              and his detailed knowledge of the JD. In addition, Denys helped me
              navigate the 4-5 interviews of the process and always offered
              timely and valuable feedback. Denys would be an asset to any
              recruiting team.
              <div className={styles.title}>Strategic Risk VP</div>
            </div>
          </div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial2}>
              Denys is one of the most helpful and professional recruiters and
              consultants I met and worked with. He helped me get a life
              changing opportunity. He always communicated promptly and
              honestly, was easy to understand, and flexible. Along the way in
              each step of the hiring process, Denys was keen to help and give
              important perspectives and advice that very much helped me
              successfully obtain this job.
              <div className={styles.title}>
                Associate Director - Banks Analyst
              </div>
            </div>
          </div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial1}>
              I had a great experience working with Denys. He was excellent at
              communicating the details of the job role and kept me
              well-informed throughout the process. He also facilitated smooth
              communication between me and the hiring manager, which made
              everything much easier. I would definitely recommend his services
              to anyone looking for opportunities in the industry.
              <div className={styles.title}>Operational Risk Manager</div>
            </div>
          </div>
          <div className={styles.testimonialContainer}>
            <div className={styles.testimonial2}>
              Professional, efficient, and the most friendly recruiter I've met!
              Was such a great experience working with Denys.
              <div className={styles.title}>ESG Rating Analyst</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.messageFromFounder} ref={messageSectionParent}>
        <div className={`${styles.grid} ${styles.gridNoVerticalSpacing}`}>
          <div className={styles.title} ref={messageFromFounderTitle}>
            Message from our Founder
          </div>
          <div className={styles.genysPhoto} ref={PP}>
            <img src={GenysPP} />
          </div>
          <div className={styles.messageSection} ref={messageSection}>
            <div className={styles.title}>Denys Maksymenko</div>
            <div className={styles.subtitle}>Founder & Director</div>
            <div className={styles.spiel}>
              At Maximal Search, we’re here to break the mould of traditional
              recruitment. Too often, recruiters rely on a revolving door of the
              same few candidates, but we take a different approach. We invest
              the time to deeply understand your business, ensuring our
              solutions are tailored for the long term. We pride ourselves on
              our innate understanding of the market and the ability to place
              candidates who are not only the perfect fit today but are
              committed to growing with you and your business for the future.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.uploadCV}>
        <div
          className={`${styles.grid} ${styles.gridNoVerticalSpacing}`}
          ref={uploadCV}
        >
          <div className={styles.title}>Upload Your CV</div>
          <div className={styles.uploadCVText}>
            Looking to grow your career? Submit your resume here to take the
            next step.
          </div>
          <div className={styles.buttonContainer}>
            <div className={styles.button} onClick={handleShowUploadCV}>
              Upload Your CV
            </div>
          </div>
        </div>
      </div>
      <div
        className={classNames(styles.u)}
        ref={uploadCVRef}
        style={{
          position: "fixed",
          top: 0,
          left: "100%",
          width: "100%",
          height: "100%",
          zIndex: 1000,
          background: "white",
        }}
      >
        <UploadCV handleCloseUploadCV={handleCloseUploadCV} />
      </div>

      <div className={styles.footer}>
        <div
          className={`${styles.grid} ${styles.grid32Spacing}`}
          ref={footerHeader}
        >
          <div className={styles.footerLogo}>
            <img src={MSLogoBlack} />
          </div>
          <div className={styles.getInTouch} ref={getInTouch}>
            <div>
              For detailed market trends and specific hiring advice, please
              connect with us below.
            </div>
          </div>
        </div>
        <div className={`${styles.grid} ${styles.gridAddedSpacing2}`}>
          <div className={styles.homeLinks} ref={footerHomeLinks}>
            <div className={styles.footerTitle}> Links </div>
            <div onClick={scrollToTop} className={styles.links}>
              {" "}
              Home{" "}
            </div>
            <div onClick={scrollToMessage} className={styles.links}>
              {" "}
              About{" "}
            </div>
            <div onClick={scrollToServices} className={styles.links}>
              {" "}
              Services{" "}
            </div>
          </div>
          <div className={styles.socialLinks} ref={footerSocialLinks}>
            <div className={styles.footerTitle}> Connect </div>
            <div ref={footerLink1}>
              <Link to="mailto:Denys.maksymenko@gmail.comm">Email</Link>
            </div>
            <div ref={footerLink2}>
              <Link to="https://wa.me/+447766524128">Whatsapp</Link>{" "}
            </div>
            <div ref={footerLink3}>
              <Link to="https://fr.linkedin.com/in/denys-maksymenko">
                LinkedIn
              </Link>{" "}
            </div>
            <div
              onClick={handleShowUploadCV}
              className={styles.cursorPointer}
              ref={footerLink4}
            >
              Upload CV{" "}
            </div>
          </div>
          <div className={styles.location} ref={footerLocation}>
            <div className={styles.footerTitle}> Find us in... </div>
            <div> London, UK </div>
            <div> Paris, France </div>
            {/* <div> Dubai, UAE </div> */}
          </div>
        </div>
        <div
          className={`${styles.gridFooter} ${styles.gridFooterSpacing}`}
          ref={footerFinalLinks}
        >
          <div className={styles.rightsReserved}>
            <div> All rights reserved Maximal Search 2025 </div>
          </div>
          <Link className={styles.privacyPolicy} to="/privacypolicy">
            <div> Privacy Policy / Terms </div>
          </Link>
          <div className={styles.backToTop} onClick={scrollToTop}>
            <div> Back to top </div>
          </div>
        </div>
      </div>
    </div>
  );
}
